export default "__VITE_ASSET__e78b6ef0__"